import React from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import useAuthStore from "../../stores/useAuthStore";
import { axiosget, axiospost } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import is_money from "../../helpers/is_money";
import IHavePaid from "../../components/IHavePaid";
import is_null from "../../helpers/is_null";

const NewFee = () => {
  const [loading, setloading] = React.useState(true);

  const [loadRRR, setloadRRR] = React.useState(false);
  const [serviceid, setserviceid] = React.useState(0);
  const [total, settotal] = React.useState(0);
  const [complete, setcomplete] = React.useState(0);
  const [scholar, setscholar] = React.useState(0);
  const [list, setlist] = React.useState(undefined);
  // const [session, setsession] = React.useState(undefined);
  const { user, settings } = useAuthStore();
  const navigate = useNavigate();
  React.useEffect(() => {
    (async () => {
      try {
        const trx = await axiosget("ms_transaction/new");
        if (trx?.data !== null) {
          setTimeout(() => navigate("/dashboard"), 500);
          return;
        } else {
          const req = await axiosget("ms_session/active");
          if (req.data?.type) {
            throw new Error(req.data?.message);
          }
          // setsession(req.data);
          const ex = _extractor(user);
          const fee_group = await axiospost(`ms_tuition_fee_items/new`, {
            programme: ex.programme,
            level: ex.level,
            student: user?._id,
            semester: ex.semester,
            indigene: ex.stateoforigin,
          });
          const { check, serviceId, scholar: scholarship } = fee_group.data;
          let sum = await check?.map((r) => r.amount)?.reduce((a, b) => a + b, 0);
          setcomplete(sum);
          if (!is_null(scholarship) && Number.parseFloat(scholarship?.percentage) >= 1) {
            const { percentage } = scholarship;
            const percentile = Number.parseFloat(percentage) / 100;
            setscholar(percentage);
            sum = sum * percentile;
          }
          settotal(sum);
          setserviceid(serviceId);
          setlist(check);
        }
      } catch ({ message }) {
        console.warn(message);
      }
      setloading(false);
    })();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _extractor = (user) => {
    const { level, semester, stateoforigin, programme } = user;
    const splits = String(level).split(" ");
    let lev = Number.parseInt(splits[0]);
    let sem = semester === "First Semester" ? 1 : 2;
    let origin = stateoforigin === "Bauchi" ? 2 : 3;
    return { level: lev, semester: sem, stateoforigin: origin, programme };
  };

  const _generateRRR = async () => {
    try {
      setloadRRR(true);
      const ex = _extractor(user);

      // Route RRR generation through backend — credentials stay server-side
      const response = await axiospost("ms_transactions/initialize", {
        amount: total,
        items: list,
        level: ex.level,
        semester: ex.semester,
        serviceId: serviceid,
      });

      setloadRRR(false);

      if (!response?.data?.success) {
        swal("error", response?.data?.message || "Failed to initialize payment", undefined, false);
        return;
      }

      const { gatewayReference, paymentUrl } = response.data.data;

      swal(
        "success",
        `<p>Your payment has been initialized</p>
        <br/>
        <h1>${gatewayReference}</h1>
        <br/>
        <p>Please copy it and keep it safe. Click OK to proceed to payment.</p>`,
        () => { if (paymentUrl) window.open(paymentUrl, "_blank"); },
        false
      );
    } catch ({ message }) {
      swal("error", message, setloadRRR, false);
    }
  };

  return (
    <div className="main-panel">
      <div className="content-wrapper d-flex align-items-center auth px-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="auth-form-light text-left py-1 px-4 px-sm-5">
                <div className="brand-logo text-center mb-4">
                  <img src={settings?.logo || "/images/college-logo.png"} alt="ATBCOE Kangere" style={{ height: 80 }} />
                </div>
                <div className="text-center mb-4">
                  <h4 style={{ fontWeight: "bold" }}>{settings?.institutionName || "ADAMU TAFAWA BALEWA COLLEGE OF EDUCATION, KANGERE"}</h4>
                  <p className="text-muted">You are required to pay for the following items:</p>
                  <hr />
                  <div className="text-left mt-3">
                    <h5 className="mb-2"><strong>NAME:</strong> {String(user.firstname).toLocaleUpperCase()} {user.middlename} {user.lastname}</h5>
                    <h5><strong>STUDENT ID:</strong> {user.studentid}</h5>
                  </div>
                </div>
                <div className="pt-3">
                  {loading ? (
                    <div className="text-center py-5">
                      <Loader />
                      <p>Please wait while we verify your payment</p>
                    </div>
                  ) : (
                    <div className="mt-3">
                      <div className="table-responsive mb-3">
                        <table className="table table-hover table-bordered" id="example">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Description</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {list?.map((v, i) => (
                              <tr key={v._id}>
                                <th>{i + 1}</th>
                                <th>{v.label}</th>
                                <th>{is_money(v.amount)}</th>
                              </tr>
                            ))}
                            {scholar && (
                              <>
                                <tr>
                                  <th>{list?.length + 1}</th>
                                  <th>Expected Total </th>
                                  <th>{is_money(complete)}</th>
                                </tr>
                                <tr>
                                  <th>{list?.length + 2}</th>
                                  <th>Scholarship</th>
                                  <th>{scholar}% off</th>
                                </tr>
                              </>
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colSpan={2}> Total</th>
                              <th>{is_money(total)}</th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                      <div className="my-3">
                        <IHavePaid total={total} />
                        {loadRRR ? (
                          <button className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">Generating RRR Code</button>
                        ) : (
                          <button onClick={_generateRRR} className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">
                            Generate RRR for {is_money(total)} to continue registration
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewFee;
